import dayjs from 'dayjs';

export const getStartEvent = (eventBeginAt: string, eventEndAt: string) => {
	const currentTime = dayjs();
	const startTime = dayjs(eventBeginAt.replaceAll('.', '-'));
	const endTime = dayjs(eventEndAt.replaceAll('.', '-'));

	return currentTime.isAfter(startTime) && currentTime.isBefore(endTime);
};
